import { Link } from "react-router-dom";

const features = [
  {
    icon: "bi-envelope-paper-fill",
    title: "Réception par courriel",
    text: "Vos fax entrants arrivent directement dans votre boîte courriel, en format PDF, prêts à être lus ou imprimés.",
  },
  {
    icon: "bi-printer-fill",
    title: "Envoi depuis votre imprimante",
    text: "Numérisez un document depuis votre imprimante multifonction et envoyez-le comme un fax, sans appareil dédié.",
  },
  {
    icon: "bi-shield-lock-fill",
    title: "Transmission sécurisée",
    text: "Vos documents, y compris les dossiers patients, transitent de façon chiffrée — important en milieu de santé.",
  },
  {
    icon: "bi-hash",
    title: "Votre numéro, votre choix",
    text: "Obtenez un nouveau numéro de fax dédié à l'ouverture, ou conservez simplement celui que vous utilisez déjà — sans interruption.",
  },
  {
    icon: "bi-cloud-arrow-down-fill",
    title: "Sans télécopieur",
    text: "Plus besoin d'un appareil physique : tout se gère en ligne ou par courriel, ce qui libère de l'espace au bureau.",
  },
  {
    icon: "bi-clock-history",
    title: "Historique conservé",
    text: "Consultez vos fax envoyés et reçus en tout temps depuis votre portail en ligne.",
  },
];

export default function TelephonieFax() {
  return (
    <>
      <section className="hero-section section">
        <div className="hero-blob" />
        <div className="container position-relative">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6" data-aos="fade-right">
              <span className="eyebrow">Téléphonie &middot; Fax</span>
              <h1 className="fw-900 mt-3 display-5">
                Envoyez et recevez vos fax par courriel
              </h1>
              <p className="lead text-secondary mt-3">
                Un service de fax entrant et sortant sécurisé, sans télécopieur.
                Pratique pour les cliniques qui échangent des documents par fax
                avec d'autres professionnels de la santé — sans avoir à garder
                un appareil dédié qui prend de la place et qui brise au pire
                moment.
              </p>

              <div className="hero-btns mt-4">
                <div className="price-pill">
                  À partir de <strong>20,00&nbsp;$</strong> / mois
                </div>
                <Link to="/contact" className="btn btn-brand rounded-pill">
                  Obtenir mon numéro de fax
                </Link>
              </div>
              {/* NOTE FRAIS */}
              <p
                className="text-secondary mt-3 mb-0"
                style={{ fontSize: "0.85rem" }}
              >
                <i className="bi bi-info-circle me-1 text-brand"></i>
                Des frais de configuration et d'installation peuvent s'appliquer
                lors de la mise en place du service.
              </p>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <div className="call-card p-4">
                <div className="d-flex justify-content-between align-items-center pb-3 border-bottom">
                  <span className="font-mono small text-secondary">
                    FAX REÇUS
                  </span>
                  <span className="pulse-dot"></span>
                </div>
                <div className="mt-3 d-flex flex-column gap-2">
                  {[
                    {
                      from: "Pharmacie Jean-Coutu",
                      pages: "2 pages",
                      time: "08:42",
                    },
                    {
                      from: "Laboratoire Biron",
                      pages: "1 page",
                      time: "Hier",
                    },
                    {
                      from: "Compagnie d'assurance",
                      pages: "4 pages",
                      time: "Hier",
                    },
                  ].map((f) => (
                    <div
                      key={f.from}
                      className="d-flex align-items-center justify-content-between rounded-3 px-3 py-2"
                      style={{ background: "var(--cpuc-cream)" }}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-file-earmark-pdf-fill text-brand"></i>
                        <div>
                          <p
                            className="small fw-bold mb-0"
                            style={{ color: "var(--cpuc-black)" }}
                          >
                            {f.from}
                          </p>
                          <p className="small text-secondary mb-0">{f.pages}</p>
                        </div>
                      </div>
                      <span className="font-mono small text-secondary">
                        {f.time}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section pt-0">
        <div className="container">
          <span className="eyebrow" data-aos="fade-up">
            Ce que ça permet
          </span>
          <h2 className="fw-900 mt-3" data-aos="fade-up">
            Le fax, en version moderne
          </h2>

          <div className="row g-4 mt-3">
            {features.map((f, i) => (
              <div
                className="col-md-6 col-lg-4"
                key={f.title}
                data-aos="fade-up"
                data-aos-delay={(i % 3) * 100}
              >
                <div className="service-card p-4">
                  <div className="service-icon mb-3">
                    <i className={`bi ${f.icon}`}></i>
                  </div>
                  <h3 className="h6 fw-bold">{f.title}</h3>
                  <p className="text-secondary small mb-0">{f.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-cream">
        <div className="container">
          <div
            className="quote-block p-4 p-md-5 text-center"
            data-aos="zoom-in"
          >
            <h2 className="fw-900 mb-3" style={{ color: "#fff" }}>
              Envoyez votre premier fax aujourd'hui!
            </h2>
            <p className="mb-4" style={{ color: "rgba(255,255,255,0.85)" }}>
              On configure votre numéro et on vous montre comment l'utiliser
              depuis votre courriel ou votre imprimante.
            </p>
            <Link
              to="/contact"
              className="btn btn-lg rounded-pill px-4"
              style={{
                background: "#fff",
                color: "var(--cpuc-red)",
                fontWeight: 700,
              }}
            >
              Discuter de mon projet
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
